import { Paper, Stack, useTheme } from '@mui/material';
import { OrganizationProfessionalUpcomingVisitContent } from 'src/sections/@dashboard/organization/components/OrganizationProfessionals/OrganizationProfessional/OrganizationProfessionalUpcomingVisitContent';
import { OrganizationProfessionalWaitingRoomContent } from 'src/sections/@dashboard/organization/components/OrganizationProfessionals/OrganizationProfessional/OrganizationProfessionalWaitingRoomContent';

export default function OrganizationProfessionalTabsWaitingRoomPage() {
  const theme = useTheme();

  return (
    <Stack sx={{ height: 1, gap: 3 }}>
      <OrganizationProfessionalUpcomingVisitContent />
      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <OrganizationProfessionalWaitingRoomContent />
        </Stack>
      </Paper>
    </Stack>
  );
}
